<template>
  <button
    class="collapse-button inverted"
    type="button"
    v-if="anyFacetsSelected"
    @click="clearSelectedFacets"
  >
    <Icon :type="'fa-xmark'" />
    <span>{{ text }}</span>
  </button>
</template>

<script>
import Icon from "../../image/icon.vue";

export default {
  name: "ClearFacetsBtn",
  props: {
    text: String,
    anyFacetsSelected: Boolean,
  },
  components: {
    Icon,
  },
  methods: {
    clearSelectedFacets() {
      this.$emit("clearSelectedFacets");
    },
  },
};
</script>
